import React from 'react';
import AppRoutes from './routes/AppRoutes';
import Header from './components/header/frontend/header'
import Footer from "./components/footer/frontend/footer";
import CookieConsent from "./components/cookie-consent/index";

function App() {
    return (
        <div>
            <Header />
            <CookieConsent />
            <AppRoutes />
            <Footer />
        </div>
    );
}

export default App;
